import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _class, _descriptor, _descriptor2;
import { Collection } from 'core/model/Collection';
import { action, observable } from 'mobx';
/**
 * This represents a "View" belonging to a Collection, allowing us to expose a subset of Collection data without modifying
 * the parent Collection at all.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export let ViewCollection = (_dec = observable.ref, _class = class ViewCollection extends Collection {
  /**
   * @param data generally this should be filtered data, though you might alternatively perform filtering after instantiation.
   * @param parentCollection
   * @param options options for creating the Collection.
   */
  constructor(data, parentCollection, options = {}) {
    super(data, options);
    _initializerDefineProperty(this, "parentCollection", _descriptor, this);
    /**
     * This is the main reason this class exists in the first place - we need to propagate changes in the View back into the parent.
     */
    _initializerDefineProperty(this, "remove", _descriptor2, this);
    this.parentCollection = parentCollection;
  }
  get url() {
    console.error('Illegal attempt to fetch from a ViewCollection');
    return '';
  }
  get model() {
    return this.parentCollection?.model;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "parentCollection", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "remove", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return (ids, destroyModels) => {
      this.parentCollection.remove(ids, destroyModels);
    };
  }
}), _class);